define((require) => {
    "use strict";

    const BreakpointGroup           = require("shared/ui/breakpoint/BreakpointGroup");
    const ExperienceModel           = require("shared/ui/experience/ExperienceModel");
    const ExperienceThumbnailViewer = require("ui/viewer/ExperienceThumbnailViewer");
    const LoggedInUserState         = require("shared/ui/user/LoggedInUserState");
    const Marionette                = require("marionette");
    const Promise                   = require("shared/util/Promise");
    const SceneThumbnailViewer      = require("ui/viewer/SceneThumbnailViewer");
    const template                  = require("ui/projects/ProjectItemView.tpl");
    const Tooltip                   = require("ui/common/Tooltip");

    const MAX_THUMB_DIMENSION = {width: 130, height: 70};
    const EXPERIENCE_RESOURCE_TYPE = "Experience";
    const BREAKPOINT_GROUP_RESOURCE_TYPE = "BreakpointGroup";

    /**
     * Item view for rendering a project thumbnail.
     *
     * @cfg {ProjectModel} model
     *
     * @class ProjectItemView
     */
    return Marionette.Layout.extend({

        className: "project-item",

        template,

        _assets: [],

        templateHelpers() {
            const assetsCount = this._assets ? this._assets.length : 0;
            const experienceLabel = `${assetsCount} Experience${(assetsCount !== 1 ? "s" : "")}`;
            return {
                projectName: this.model.get("name"),
                experienceCountLabel: experienceLabel,
                cannotDelete: this.options.cannotDelete
            };
        },

        regions: {
            experienceThumb: ".experience-thumb"
        },

        ui: {
            projectThumb: ".project-thumb",
            delete: ".delete",
            disabledDelete: ".delete.disabled"
        },

        events: {
            "click @ui.delete": "_clickDeleteHandler"
        },

        triggers: {
            "click @ui.projectThumb": {
                event: "select:project",
                // Default is true (we want to execute the default anchor .project-thumb logic on click)
                preventDefault: false
            }
        },

        initialize() {
            const experienceAssets = this.model.get("assets").models.filter((model) =>
                model.get("resourceType") === EXPERIENCE_RESOURCE_TYPE);

            const breakpointGroupAssets = this.model.get("assets").models.filter((model) =>
                model.get("resourceType") === BREAKPOINT_GROUP_RESOURCE_TYPE);

            this._assets = [...experienceAssets, ...breakpointGroupAssets];
        },

        onRender() {
            const experienceThumbRegion = this.experienceThumb;

            if (this.options.cannotDelete) {
                Tooltip.add(this.ui.disabledDelete, {width: 180, placement: "top"});
            } else {
                Tooltip.add(this.ui.delete, {width: 135, placement: "top"});
            }

            if (!LoggedInUserState.get("companySettings").get("lazyLoadProjectsMenu")) {
                this._experienceFetch().then((experienceModel) => {
                    if (experienceModel) {
                        let experienceThumb;
                        if (LoggedInUserState.get("integrations").isThumbnailsNativeContentIntegrationsEnabled()) {
                            experienceThumb = new ExperienceThumbnailViewer({
                                model: experienceModel.get("scenes").at(0),
                                experience: experienceModel,
                                maxDimensions: MAX_THUMB_DIMENSION,
                                showStaticScenes: true
                            });
                        } else {
                            experienceThumb = new SceneThumbnailViewer({
                                model: experienceModel.get("scenes").at(0),
                                experience: experienceModel,
                                maxDimensions: MAX_THUMB_DIMENSION,
                                showStaticScenes: true
                            });
                        }
                        experienceThumbRegion.show(experienceThumb);
                    }
                });
            }
        },

        _clickDeleteHandler() {
            // Force hiding of the tooltip. The `mouseout` event does not seem to trigger
            // when we open a native promt/alert when clicking the delete button.
            Tooltip.hide(this.ui.delete);
            this.triggerMethod("delete:project", this);
        },

        _experienceFetch() {
            let modelFetch = Promise.resolved();
            const targetAsset = this._assets[0];
            if (targetAsset) {
                const resourceType = targetAsset.get("resourceType");
                const resourceId = targetAsset.get("resourceId");

                if (resourceType === EXPERIENCE_RESOURCE_TYPE) {
                    const experienceModel = new ExperienceModel({id: resourceId});
                    modelFetch = experienceModel.fetch();
                } else if (resourceType === BREAKPOINT_GROUP_RESOURCE_TYPE) {
                    const breakpointGroup = new BreakpointGroup({id: resourceId}, {pushedOnly: true});
                    modelFetch = breakpointGroup.fetchPushedOnly()
                        .then((response) => {
                            if (response) {
                                return response.getSortedAssets("editedAt")[0];
                            }
                        });
                }
            }

            return modelFetch;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/projects/ProjectItemView.js